import { currentBreakpoint, currentOrientation } from "../../exports/viewport";
import { defineStore } from "../nexus/defines";
import { setDevSpecsCookie } from "./tracking/devSpecCookie";
import {
  breakpointChangeListener,
  orientationChangeListener,
  updtateTrackingViewportData,
} from "./tracking/trackingHandler";
import {
  initializeBreakpointHandler,
  getCurrentBreakpoint,
  isActiveBreakpoint,
  withBreakpoints,
} from "./breakpoint/breakpoint";
import {
  initializeOrientationHandler,
  getCurrentOrientation,
  isActiveOrientation,
  withOrientations,
} from "./orientation/orientation";
import type { Breakpoint, BreakpointUnknown } from "./breakpoint/types";
import type { Orientation, OrientationUnknown } from "./orientation/types";
import { getScrollbarWidth } from "./scrollbar/scrollbar";
import { otto } from "../../exports/nexus";

otto.viewport.assignNamespace({
  /*         */
  currentBreakpoint: defineStore<Breakpoint | BreakpointUnknown | undefined>(
    getCurrentBreakpoint(),
  ),
  getCurrentBreakpoint,
  isActiveBreakpoint,
  withBreakpoints,

  /*          */
  currentOrientation: defineStore<Orientation | OrientationUnknown | undefined>(
    getCurrentOrientation(),
  ),
  getCurrentOrientation,
  isActiveOrientation,
  withOrientations,

  getScrollbarWidth,

  /*                                  */
  /*                                                          */
  __breakpoints: { $: defineStore<any>() },
  /*                                                          */
  __orientations: { $: defineStore<any>() },
});

/*                                                */
initializeBreakpointHandler();
initializeOrientationHandler();

/*                                 */
currentBreakpoint.sub(setDevSpecsCookie);

/*                                                */
/*                                             */
updtateTrackingViewportData();
/*                                                        */
currentBreakpoint.sub(breakpointChangeListener, { skipRetained: true });
currentOrientation.sub(orientationChangeListener, { skipRetained: true });
